import { FC, SVGProps } from 'react';

export const CheckmarkIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.1165 9.92329C26.6456 9.35038 26.625 8.44876 26.0682 7.9019C25.5028 7.34659 24.6025 7.37005 24.0653 7.95173L12.945 19.9929L7.91087 14.8015C7.35941 14.2328 6.45877 14.2328 5.90732 14.8015C5.36423 15.3616 5.36423 16.2634 5.90732 16.8235L11.9679 23.0735C12.2351 23.349 12.6023 23.5047 12.9871 23.4999C13.3719 23.4951 13.735 23.3302 13.9953 23.0483L26.1165 9.92329Z"
			fill="currentColor"
		/>
	</svg>
);
